(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/helpers/conditionals.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/helpers/conditionals.js');

'use strict';

function isInternationalProduct(productId) {
  return svs.numbergames.productMapping.isEurojackpot(productId) || svs.numbergames.productMapping.isVikinglotto(productId);
}
svs.numbergames.results_common.conditionals = {
  isInternationalProduct
};

 })(window);